function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Modal from '../components/modal';
import ChooseFlavorButton from '../components/chooseFlavorButton';
import { useShopifyCart } from '../../common/hooks';
import { trackAddToCartEvent } from '../../trackers/utils';
import { getFreeGiftCartUpdate } from '../../common/freeGifts';
import { AjaxCartAdapter } from '../../trackers/adapater/cart/ajaxCartAdapter';
export default function PDPOneThreeSixFlavorSelector(_ref) {
  var buy1ButtonContainer = _ref.buy1ButtonContainer,
      buy3ButtonContainer = _ref.buy3ButtonContainer,
      buy6ButtonContainer = _ref.buy6ButtonContainer,
      product = _ref.product,
      buy1SnsButtonContainer = _ref.buy1SnsButtonContainer,
      buy3SnsButtonContainer = _ref.buy3SnsButtonContainer,
      buy6SnsButtonContainer = _ref.buy6SnsButtonContainer,
      buy1SnsSellingPlanId = _ref.buy1SnsSellingPlanId,
      buy3SnsSellingPlanId = _ref.buy3SnsSellingPlanId,
      buy6SnsSellingPlanId = _ref.buy6SnsSellingPlanId,
      productOverride = _ref.productOverride;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalOpen = _useState2[0],
      setIsModalOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      modalSellingPlanId = _useState4[0],
      setModalSellingPlanId = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedQuantity = _useState6[0],
      setSelectedQuantity = _useState6[1];

  var _useShopifyCart = useShopifyCart(),
      loading = _useShopifyCart.loading,
      error = _useShopifyCart.error,
      cart = _useShopifyCart.cart,
      addedItems = _useShopifyCart.addedItems,
      addToCart = _useShopifyCart.addToCart;

  useEffect(function () {
    function afterAddToCart() {
      trackAddToCartEvent(new AjaxCartAdapter(addedItems, cart)); // 300ms - time to let Klaviyo event fire

      setTimeout(function () {
        window.location.assign('/cart');
      }, 300);
    }

    if (!loading && addedItems && addedItems.length) {
      afterAddToCart();
    }
  }, [addedItems, cart, loading]);
  useEffect(function () {
    function onError() {
      console.error('Failed adding items to cart', error);
      window.alert('There was a problem. Please try again.');
    }

    if (error) {
      onError();
    }
  }, [error]);

  function handleButtonClick(quantity, sns) {
    var sellingPlanId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return function (evt) {
      // prevents button from submitting containing form
      evt.preventDefault();

      if (sns) {
        // set selling plan id for flavor selector modal, enabling SNS mode
        setModalSellingPlanId((productOverride === null || productOverride === void 0 ? void 0 : productOverride.sellingPlanId) || sellingPlanId);
      } else {
        // clear sellingPlanId, which puts Flavor Selector Modal into one-time mode
        setModalSellingPlanId(null);
      }

      setSelectedQuantity(quantity);
      setIsModalOpen(true);
      return true;
    };
  }

  function handleAddToCart() {
    var variantQuantities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    addToCart(variantQuantities, getFreeGiftCartUpdate());
  }

  function handleCloseModal() {
    setIsModalOpen(false);
  }

  return (
    /*#__PURE__*/

    /* eslint-disable quotes */

    /* ¯\_(ツ)_/¯ */
    React.createElement(React.Fragment, null, /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ChooseFlavorButton, {
      className: "choose1 group1",
      onClick: handleButtonClick(1, false),
      quantity: 1
    }, "Choose Flavor"), buy1ButtonContainer), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ChooseFlavorButton, {
      className: "choose3 group1",
      onClick: handleButtonClick(3, false),
      quantity: 3
    }, "Choose Flavors"), buy3ButtonContainer), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ChooseFlavorButton, {
      className: "choose6 group1",
      onClick: handleButtonClick(6, false),
      quantity: 6
    }, "Choose Flavors"), buy6ButtonContainer), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ChooseFlavorButton, {
      className: "choose1 group1",
      onClick: handleButtonClick(1, true, buy1SnsSellingPlanId),
      quantity: 1
    }, "Choose Flavor"), buy1SnsButtonContainer), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ChooseFlavorButton, {
      className: "choose3 group1",
      onClick: handleButtonClick(3, true, buy3SnsSellingPlanId),
      quantity: 3
    }, "Choose Flavors"), buy3SnsButtonContainer), /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(ChooseFlavorButton, {
      className: "choose6 group1",
      onClick: handleButtonClick(6, true, buy6SnsSellingPlanId),
      quantity: 6
    }, "Choose Flavors"), buy6SnsButtonContainer), /*#__PURE__*/React.createElement(Modal, {
      isOpen: isModalOpen,
      isBusy: loading,
      sellingPlanId: modalSellingPlanId,
      quantity: selectedQuantity,
      onRequestClose: handleCloseModal,
      product: productOverride || product,
      onAddToCart: handleAddToCart
    }))
  );
}
PDPOneThreeSixFlavorSelector.propTypes = {
  buy1ButtonContainer: PropTypes.instanceOf(HTMLElement),
  buy3ButtonContainer: PropTypes.instanceOf(HTMLElement),
  buy6ButtonContainer: PropTypes.instanceOf(HTMLElement),
  buy1SnsButtonContainer: PropTypes.instanceOf(HTMLElement),
  buy3SnsButtonContainer: PropTypes.instanceOf(HTMLElement),
  buy6SnsButtonContainer: PropTypes.instanceOf(HTMLElement),
  buy1SnsSellingPlanId: PropTypes.number,
  buy3SnsSellingPlanId: PropTypes.number,
  buy6SnsSellingPlanId: PropTypes.number,
  product: PropTypes.object,
  productOverride: PropTypes.object
};